import { request } from "../../../../apis";

export const apiChangePass = (params: ChangePasswordParams) =>
  request("post", `/api/user/change/password`, params, true);
